import { i18n } from "@tellescope/i18n";
import { cn, DialogDescription, DialogHeader } from "@tellescope/ui";
import { ComponentProps } from "react";
import heroBackgroundUrl from "../../assets/hero-background.avif?w=1920&format=avif&imagetools";

export interface SetupDialogHeaderProps extends Omit<ComponentProps<typeof DialogHeader>, "children"> {
  title?: string;
  description?: string;
}

export const SetupDialogHeader = ({
  title = i18n.t("Tellescope Setup", { ns: "onboarding" }),
  description = i18n.t("Tellescope works better with the tools you already use, configure your integrations here.", {
    ns: "onboarding",
  }),
  style,
  className,
  ...rest
}: SetupDialogHeaderProps) => {
  return (
    <DialogHeader
      {...rest}
      style={{
        backgroundImage: `url(${heroBackgroundUrl})`,
        backgroundSize: "cover",
        backgroundPosition: "top center",
        ...style,
      }}
      className={cn("space-y-1 px-8 py-6", className)}
    >
      <h2 className="font-bold text-white" style={{ fontSize: "clamp(28px, 4vw, 48px)" }}>
        {title}
      </h2>
      {!!description && <DialogDescription className="text-white text-md">{description}</DialogDescription>}
    </DialogHeader>
  );
};
